"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var camelCase = require('lodash/camelCase');
/**
 * @interface Component
 * @param {String} params.component_type
 * @param {Number} params.quantity
 */


var Component = /*#__PURE__*/function () {
  function Component() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Component);

    this.component_type = params.component_type;
    this.quantity = parseInt(params.quantity, 10) || 0;
  }
  /**
     * @returns {String}
     */


  _createClass(Component, [{
    key: "type",
    get: function get() {
      return this.component_type.replace(/\s/g, '');
    }
  }, {
    key: "identifier",
    get: function get() {
      if (this.name.match(/x$/)) {
        return "".concat(camelCase(this.name), "es");
      }

      return "".concat(camelCase(this.name), "s");
    }
    /**
       * @returns {String}
       */

  }, {
    key: "name",
    get: function get() {
      return this.type;
    }
    /**
       * override this method in components composed of other components.
       * e.g. InvitationEnvelopes are composed of A7Envelopes, A75Envelopes, EnvelopeLiners, etc.
       * Must be functional, not changing internal state of Component object.
       * @returns {Array<Component>} Components[]
       */

  }, {
    key: "subcomponents",
    get: function get() {
      return this;
    }
  }, {
    key: "component_weight",
    value: function component_weight(paper_type) {
      // get component weight settings
      var weight_options = this.COMPONENT_WEIGHT;
      var instance_weight = 0.1;

      if (_typeof(weight_options) === 'object') {
        // then the weight is based on the paper type
        // if paper_type is undefined, this component's weight
        // should probably be specified in the settings,
        // but we'll let it default to 0.1 and warn the user.
        if (weight_options[paper_type]) {
          instance_weight = weight_options[paper_type];
        } else {
          console.warn("".concat(this.component_type, " failed to extract a component_weight from the settings"));
        }
      } else {
        // then the weight is given as a number
        instance_weight = weight_options;
      }

      return instance_weight;
    }
  }, {
    key: "total_weight",
    value: function total_weight(paper_type) {
      return this.quantity * this.component_weight(paper_type);
    }
    /**
       * @param {Object} params - key/value pairs to set
       * @returns {Component} this
       */

  }, {
    key: "set",
    value: function set(obj) {
      var _this = this;

      if (Object.prototype.toString.call(obj) !== '[object Object]') {
        throw new Error('set() must receive an object!');
      }

      Object.keys(obj).forEach(function (parameter) {
        if (!Object.prototype.hasOwnProperty.call(_this, parameter)) {
          throw new Error("".concat(parameter, " is not a valid parameter"));
        }

        _this[parameter] = obj[parameter];
      });
      return this;
    }
  }]);

  return Component;
}();

module.exports = Component;